import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ArrowRight } from "lucide-react";
export default function GroundworkDrainage() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="58716" id="våra-certifieringar" className="bg-background text-foreground py-24 relative overflow-hidden" ref={ref}>
      {}
      <div className="absolute inset-0 pointer-events-none opacity-[0.03] z-0">
        <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="grid-pattern" width="40" height="40" patternUnits="userSpaceOnUse">
              <path d="M 40 0 L 0 0 0 40" fill="none" stroke="currentColor" strokeWidth="1" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#grid-pattern)" />
        </svg>
      </div>

      <div className="container mx-auto px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {}
          <div className={`flex flex-col items-start text-left transition-all duration-700 delay-100 ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-10"}`}>
            <h2 className="text-4xl md:text-5xl font-bold font-default mb-6 text-foreground tracking-tight">
              Certifierad Trygghet
            </h2>
            <p className="text-lg md:text-xl font-default text-muted-foreground mb-8 leading-relaxed max-w-xl">Vårt moderbolag RSAB Rörservice AB är auktoriserat enligt Säker Vatten, och vi samarbetar uteslutande med certifierade våtrumsmontörer anslutna till Byggkeramikrådet (BKR) och GVK. För dig som kund innebär detta att din badrumsrenovering utförs med högsta precision enligt stränga svenska branschregler, vilket är helt avgörande för både försäkringsskydd, långvarig hållbarhet och ett godkänt våtrumsintyg.</p>
            <Button asChild className="rounded-[8px] px-8 py-6 text-lg font-semibold font-default bg-primary text-primary-foreground hover:bg-primary/90 shadow-lg hover:shadow-xl transition-all">
              <Link to="/QuoteRequestPage">
                BEGÄR OFFERT
                <ArrowRight className="ml-2 h-5 w-5" />
              </Link>
            </Button>
          </div>

          {}
          <div className={`relative group transition-all duration-700 delay-300 ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-10"}`}>
            {}
            <div className="absolute -inset-2 bg-primary/10 rounded-2xl blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
            
            <div className="relative rounded-2xl overflow-hidden border border-border shadow-2xl bg-card">
              <AspectRatio ratio={4 / 3}>
                <img alt="Professionell badrumsrenovering utförd enligt gällande branschregler och certifieringar" className="object-cover w-full h-full transform group-hover:scale-105 transition-transform duration-700" src="https://proffsbadrum.se/wp-content/uploads/2026/09/excavation_drainage_action_optimized.webp" />
              </AspectRatio>
              
              {}
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent pointer-events-none" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}